import React from "react";

const libroLogo = props => (
  <img src={require("./libro.png")} alt='' />
);

export default libroLogo ;
